export default function Footer() {
    return (
        <footer>
            <h6>Footer Elements</h6>
        </footer>
    );
}
